var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-info-area board__header container-fluid "},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_vm._v(_vm._s(_vm.roomName))]),_c('score',{attrs:{"score":_vm.score}}),_c('div',{staticClass:"col-3"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }